import React from "react";
import styled from "styled-components";
import {asLocalTime} from "../../../../util/timeDescription";

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    color: #b6b6b6;
    font-size: 10px;
`;

export const PortfolioPerformanceTimestamp = ({generatedAt}) => {
    if (!generatedAt) {
        return null;
    }

    return <Container className="t-portfolio-performance-timestamp">
        <span>as at {asLocalTime(generatedAt)}</span>
    </Container>;
};